
    <input matInput class="d-none"
      [formControl]="formControl">
    <input matInput 
      [formControl]="formControl2"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
      (click)="onClick()"
      (keydown)="onClick()" >
  